export const isObject = (value: unknown): value is Record<string, unknown> => {
  return Object.prototype.toString.call(value) === '[object Object]';
};

type SplitArray<T> = T extends (infer U)[]
  ? // Workaround, as boolean would be split to true[] | false[] otherwise
    U extends boolean
    ? boolean[]
    : U[]
  : never;

export const isPureArray = <T>(
  arr: T[] | SplitArray<T[]>
): arr is SplitArray<T[]> => arr.every((val) => typeof val === typeof arr[0]);

export function isNotNullOrUndefined<T>(
  value: T | null | undefined
): value is T {
  return value != null;
}
